import { choose } from '../utils/platform';
import CrudFormModalDesktop from './CrudFormModal.desktop';
import CrudFormModalMobile from './CrudFormModal.mobile';

// Platform chooser: the APK renders the mobile variant, any browser the desktop one.
export default choose(CrudFormModalDesktop, CrudFormModalMobile);
